import React, { Component } from 'react'
import { Field } from './'
import { SearchBarStyle } from './../styles'

export default class SearchBar extends Component {
  state = {
    searchKey : ''
  }

  addSearch = (data) => {
    const { searchKey } = this.state
    this.setState({ searchKey: data.value }, () => {
      this.props.callback(data.value)
    })
  }

  render() {
    return (
      <div className={`searchbar ${SearchBarStyle}`}>
        <div className="fluid">
          <div className="form">
            <Field type="text" name="search" id="search" value="" onChange={this.addSearch} big> What are you looking for? </Field>
            <button type="button" className="btn-reset"> Search </button>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SearchBar.js